import React, { useState, useEffect, useRef } from "react";
import { getGreeting } from "../../utils/getGreeting";
import "./Greeting.css";

const Greeting = ({ userName = "Guest" }) => {
  const [greetingData, setGreetingData] = useState(() =>
    getGreeting(userName)
  );
  const [displayedGreeting, setDisplayedGreeting] = useState("");
  const [displayedQuote, setDisplayedQuote] = useState("");
  const timeoutRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setGreetingData(getGreeting(userName));
    }, 300000);

    return () => clearInterval(interval);
  }, [userName]);

  useEffect(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    setDisplayedGreeting("");
    setDisplayedQuote("");

    let gIndex = 0;
    let qIndex = 0;
    const gText = greetingData.greeting || "";
    const qText = greetingData.quote || "";

    const typeGreeting = () => {
      if (gIndex < gText.length) {
        setDisplayedGreeting(gText.slice(0, gIndex + 1));
        gIndex++;
        timeoutRef.current = setTimeout(typeGreeting, 45);
      } else {
        typeQuote();
      }
    };

    const typeQuote = () => {
      if (qIndex < qText.length) {
        setDisplayedQuote(qText.slice(0, qIndex + 1));
        qIndex++;
        timeoutRef.current = setTimeout(typeQuote, 28);
      }
    };

    typeGreeting();

    return () => timeoutRef.current && clearTimeout(timeoutRef.current);
  }, [greetingData]);

  return (
    <div className="greeting-wrapper">
      <div className="greeting-card">

   <div className="chat-icon-wrapper">
  <div className="chat-bubble">
    <span className="chat-dot" />
  </div>
</div>
<h1 className="greeting-text typing-cursor">
  {displayedGreeting}
</h1>

{/*<p className="greeting-meta">
  Ask questions • Explore trends • Get insights from your data
</p>*/}

<p className="quote-text">
  <span className="quote-mark"></span>
  {displayedQuote}
</p>

      </div>
    </div>
  );
};

export default Greeting;
